import React, { useContext } from "react";
import { Context } from "../../context/Context";
import MenuBtn from "../MenuBtn/MenuBtn";
export default function FloatingCard() {
  const { menus, handleMenu, isOpen } = useContext(Context);
  return (
    <div
      className={` w-full fixed bottom-12 lgx:bottom-20 flex items-center justify-center transform duration-700 px-6 lgx:px-0 ${
        isOpen ? "lgx:pl-80" : null
      }`}
    >
      <div className="w-full border bg-white    h-20 lgx:h-22 rounded-md shadow-2xl mx-auto  max-w-sm duration-700 transition flex  items-center justify-between px-3  ">
        {menus.map(({ txt, icon, id, selected }, index) => (
          <MenuBtn
            txt={txt} 
            icon={icon}
            id={id}
            selected={selected}
            handleMenu={handleMenu}
            index={index}
            key={id}
          />
        ))}
      </div>
    </div>
  );
}
